import { GenericResponseModel, LoginRequest } from "../dataModel/authModels";
import { ClientUpdatePinModel, ClientUploadSignModel } from "../dataModel/clientModels";
import { ApiRoutes } from "./apiConfig/apiEdndpoints";
import { customAxios } from "./apiConfig/useExPressApi";
import FormData from "form-data";

export const client = {
    getSign: () => {
      return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_CLIENT_SIGNATURE}`);
     },
     getClinicInfo: () => {
      return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_CLIENT_INFO}`);
     },
     getClientDocument: () => {
      return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.GET_DOCUMENT}`);
     },

     updateSign: (data:ClientUploadSignModel) => {
      return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.UPDATE_SIGNATURE}`,data);
     },

     updateSignPIN: (data:ClientUpdatePinModel) => {
      return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.RESET_PIN}`,data);
     },
    
  
}